/* jshint esversion: 6 */

const DEFAULT_SWIPER_OPTIONS = {
	//slidesPerView: 'auto',
	spaceBetween: 1,
	centeredSlides: true,
	loop: false,
	loopAdditionalSlides: 100,
	//speed: 600,
	//autoplay: {
	//delay: 8000,
	//},
	keyboard: {
		enabled: true,
		onlyInViewport: true,
	},
	mousewheelControl: false,
	onSlideClick: function (swiper) {
		angular.element(swiper.clickedSlide).scope().clicked(angular.element(swiper.clickedSlide).scope().$index);
	},
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
	a11y: {
		enabled: true,
		prevSlideMessage: 'Slide precedente',
		nextSlideMessage: 'Slide successiva',
		firstSlideMessage: 'Questa è la prima slide',
		lastSlideMessage: 'Questa è l\'ultima slide',
		paginationBulletMessage: 'Vai alla slide {{index}}',
	}
};

export class SwiperDirective {

	constructor() {
		this.restrict = 'A';
		this.options = DEFAULT_SWIPER_OPTIONS;
	}

	link(scope, element, attributes, controller) {
		scope.$on('lastItem', (slide) => {
			this.onSwiper(element);
		});
		scope.$on('$destroy', () => {
			if (element.swiper) {
				element.swiper.destroy();
				// console.log('swiper.destroy');
			}
		});
		scope.$watch('$viewContentLoaded', () => {
			this.onSwiper(element);
		});
		scope.$on('onResize', ($scope) => {
			if (element.swiper) {
				element.swiper.update();
			}
		});
	}

	onSwiper(element) {
		if (element.swiper) {
			element.swiper.update();
		} else {
			element.swiper = new Swiper(element, this.options);
			element.addClass('swiper-init');
		}
	}

	static factory() {
		return new SwiperDirective();
	}

}

SwiperDirective.factory.$inject = [];

export class SwiperHeroDirective extends SwiperDirective {

	constructor() {
		super(); this.options = {

			loop: false,
			spaceBetween: 0,
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			mousewheelControl: false,
			onSlideClick: function (swiper) {
				angular.element(swiper.clickedSlide).scope().clicked(angular.element(swiper.clickedSlide).scope().$index);
			},
			on: {
				setTransition: function () { },
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			a11y: {
				enabled: true,
				prevSlideMessage: 'Slide precedente',
				nextSlideMessage: 'Slide successiva',
				firstSlideMessage: 'Questa è la prima slide',
				lastSlideMessage: 'Questa è l\'ultima slide',
				paginationBulletMessage: 'Vai alla slide {{index}}',
			},
		};
	}

	static factory() {
		return new SwiperHeroDirective();
	}

}

SwiperHeroDirective.factory.$inject = [];

export class SwiperNewsDirective extends SwiperDirective {

	constructor() {
		super(); this.options = {
			slidesPerView: 1,
			spaceBetween: 30,
			loop: false,
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			mousewheelControl: false,
			onSlideClick: function (swiper) {
				angular.element(swiper.clickedSlide).scope().clicked(angular.element(swiper.clickedSlide).scope().$index);
			},
			on: {
				setTransition: function () { },
			},
			pagination: {
				el: '.swiper-pagination-2',
				clickable: true,
			},
			a11y: {
				enabled: true,
				prevSlideMessage: 'Slide precedente',
				nextSlideMessage: 'Slide successiva',
				firstSlideMessage: 'Questa è la prima slide',
				lastSlideMessage: 'Questa è l\'ultima slide',
				paginationBulletMessage: 'Vai alla slide {{index}}',
			},
			breakpoints: {
				640: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 40,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 50,
				},
			},
		};
	}

	static factory() {
		return new SwiperNewsDirective();
	}

}

export class SwiperColorsDirective extends SwiperDirective {

	constructor() {
		super(); this.options = {
			slidesPerView: 1,
			spaceBetween: 30,
			centeredSlides: false,
			simulateTouch: true,
			allowTouchMove: true,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			a11y: {
				enabled: true,
				prevSlideMessage: 'Slide precedente',
				nextSlideMessage: 'Slide successiva',
				firstSlideMessage: 'Questa è la prima slide',
				lastSlideMessage: 'Questa è l\'ultima slide',
				paginationBulletMessage: 'Vai alla slide {{index}}',
			},
			breakpoints: {
				640: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				768: {
					slidesPerView: 3,
					spaceBetween: 20,
					centeredSlides: false,
				}
			},
		};
	}

	static factory() {
		return new SwiperColorsDirective();
	}

}

SwiperColorsDirective.factory.$inject = [];

export class SwiperIconsDirective extends SwiperDirective {

	constructor() {
		super(); this.options = {
			slidesPerView: 1,
			spaceBetween: 30,
			watchOverflow: true,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			a11y: {
				enabled: true,
				prevSlideMessage: 'Slide precedente',
				nextSlideMessage: 'Slide successiva',
				firstSlideMessage: 'Questa è la prima slide',
				lastSlideMessage: 'Questa è l\'ultima slide',
				paginationBulletMessage: 'Vai alla slide {{index}}',
			},
			breakpoints: {
				640: {
					slidesPerView: 1,
					spaceBetween: 20,
				},
				768: {
					slidesPerView: 5,
					spaceBetween: 20,
				}
			},
		};
	}

	static factory() {
		return new SwiperIconsDirective();
	}

}

SwiperIconsDirective.factory.$inject = [];

export class SwiperCollectionsDirective extends SwiperDirective {

	constructor() {
		super();
		this.options = {
			slidesPerView: 1,
			slidesPerGroup: 1, // Aggiungi questa opzione per specificare quanti elementi scorrono alla volta
			spaceBetween: 30, pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			a11y: {
				enabled: true,
				prevSlideMessage: 'Slide precedente',
				nextSlideMessage: 'Slide successiva',
				firstSlideMessage: 'Questa è la prima slide',
				lastSlideMessage: 'Questa è l\'ultima slide',
				paginationBulletMessage: 'Vai alla slide {{index}}',
			},
			breakpoints: {
				640: {
					slidesPerView: 1,
					slidesPerGroup: 1, // Anche qui, assicurati che sia 1 su dispositivi mobili
					spaceBetween: 20,
				},
				768: {
					slidesPerView: 3,
					slidesPerGroup: 3, // Imposta questo su 3 per desktop
					spaceBetween: 20,
				}
			},
		};
	}

	static factory() {
		return new SwiperCollectionsDirective();
	}

}

SwiperCollectionsDirective.factory.$inject = [];
